
import { defineComponent, reactive, toRefs } from 'vue'
import { getRandomFromArr, AssertGoodResponse } from '@/util/GlobalUtil'
import { useLog, useGetRequest } from '@/hooks'
import { useRoute, useRouter } from 'vue-router'
import { BlogConditionStrategies } from '@/interfaces'

export default defineComponent({
  setup() {
    // eslint-disable-next-line
    const l = useLog()
    const { name: currentRouteName } = useRoute()
    const router = useRouter()
    const randomTagType = () =>
      getRandomFromArr(['', 'info', 'danger', 'warning', 'success'])
    const state = reactive({
      hotTags: [],
    })
    // 调接口, 热门标签
    useGetRequest('/api/tag/hot', { topNum: 10 }).then((res) => {
      AssertGoodResponse(res)
      state.hotTags = res.data.data
    })
    // 跳转到conditon页面, 查看当前类型下的所有博客
    // eslint-disable-next-line
    const toThisTag = (tag: any) => {
      router
        .push({
          name: 'ConditionBlogs',
          query: {
            conditionStrategy: BlogConditionStrategies.BY_TAG,
            value: tag.id,
          },
        })
        .then(() => {
          // 为什么要这么写? 因为同路由跳转组件不会刷新, 只能在跳转成功之后的回调里自动刷新一下页面
          if (currentRouteName == 'ConditionBlogs') {
            router.go(0)
          }
        })
    }

    return { ...toRefs(state), randomTagType, toThisTag }
  },
})
